// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3rpzS","notes":"Notes_notes__3lrdk"};